module.exports = __webpack_public_path__ + "static/media/showerRect180.5f6ad914.png";